import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Grid} from "@mui/material";

import CustomButton from "components/CustomButton";
import Popup from "components/WMS/Mobile/Popup";

import TrackingNumber from "../../components/TrackingNumberBlue";
import ExternalId from "../../components/ExternalId";

import {black500} from "assets/jss/main";
import {ReactComponent as BagIcon} from "assets/img/wms/bag.svg"

import ship from "api/shipment/ship";

import {ClickAndCollectHandOverContext} from "../context/ClickAndCollectHandOverContext";

HandOverShipmentPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
};

function HandOverShipmentPopup({onClose, ...props}) {
    const {
        selectedShipment,
        openToast,
        refreshShipments,
        setSelectedShipment
    } = useContext(ClickAndCollectHandOverContext);

    const [isLoading, setIsLoading] = useState(false)

    return (
        <Popup
            title={<FormattedMessage id='wms.cc.handover.handoverShipment.popup.title' />}
            subtitle={<FormattedMessage id='wms.cc.handover.handoverShipment.popup.subtitle' />}
            open={true}
            icon={<BagIcon />}
            isMobile={true}
            onClose={onClose}
        >
            <Grid container>
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'center'
                        }}
                    >
                        <b style={{ fontSize: '20px', color: black500 }}>
                            {selectedShipment.order.customerShippingFirstname} &nbsp;
                            {selectedShipment.order.customerShippingLastname}
                        </b>
                        <TrackingNumber trackingNumber={selectedShipment.trackingNumber ?? selectedShipment.externalDeliveryNumber} />
                        <ExternalId externalId={selectedShipment.order.externalId} />
                    </div>
                </Grid>
                <Grid
                    item
                    container
                    direction={'column'}
                    spacing={2}
                    marginTop={4}
                >
                    <Grid item>
                        <CustomButton
                            fullWidth={true}
                            thicker={true}
                            color={'blue'}
                            loading={isLoading}
                            onClick={() => {
                                setIsLoading(true)
                                ship(selectedShipment).then(() => {
                                    setSelectedShipment(null);
                                    openToast();
                                    refreshShipments();
                                    setIsLoading(false)
                                    onClose()
                                });
                            }}
                        >
                            <FormattedMessage id='wms.cc.handover.handoverShipment.popup.action.validate' />
                        </CustomButton>
                    </Grid>
                    <Grid item>
                        <CustomButton
                            onClick={onClose}
                            fullWidth={true}
                            thicker={true}
                            color={'default'}
                        >
                            <FormattedMessage id='wms.cc.handover.handoverShipment.popup.action.cancel' />
                        </CustomButton>
                    </Grid>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default HandOverShipmentPopup;
